import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { EventDetails } from '~entities/events/modal/event';
import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface RotatePublicEventShareLinkResult {
  shareToken: string;
}

export const rotatePublicEventShareLinkAPI = async (params: {
  eventId: string;
  regenerate: boolean;
}) => {
  const response = await baseAPI.post<RotatePublicEventShareLinkResult>(
    `/events/${params.eventId}/public-share-link`,
    { regenerate: params.regenerate },
  );
  return response.data;
};

export function useRotatePublicEventShareLink(eventId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (regenerate: boolean) =>
      rotatePublicEventShareLinkAPI({ eventId, regenerate }),
    onSuccess: (result) => {
      const shareToken =
        typeof result?.shareToken === 'string' ? result.shareToken.trim() : '';
      if (shareToken.length === 0) {
        return;
      }
      queryClient.setQueryData(
        [KEYS.EVENTS, eventId],
        (previous: EventDetails | undefined) => {
          if (previous == null) return previous;
          return { ...previous, publicEventShareToken: shareToken };
        },
      );
      queryClient.setQueryData([KEYS.EVENTS, eventId, 'public-share-link'], {
        shareToken,
      });
    },
  });
}
